import React from "react"
import Helmet from "react-helmet"
import { Row, Col } from "antd"
import Footer from "../common/footer"
import Subscribe from "../components/subscribe/"
import { Hero } from "../components/hero"
import Layout from "../common/layout"
import Navigation from "../common/navigation"
import current_access_icon from "../assets/images/solutions/current_access_icon.svg"
import swiftlane_face from "../assets/images/solutions/swiftlane_face.png"

import fast_entollment from "../assets/images/icons/fast_entollment.svg"
import real_time_activity_feed from "../assets/images/icons/real_time_activity_feed.svg"
import visual_verification from "../assets/images/solutions/visual_verification.svg"
import auditing from "../assets/images/icons/auditing.svg"
import manage_multiple_sites from "../assets/images/solutions/manage_multiple_sites.png"
import swiftlane_system from "../assets/images/solutions/commercial/swiftlane_system.png"
import swiftlane_system_icon from "../assets/images/solutions/commercial/swiftlane_system_icon.svg"
import remote_management from "../assets/images/icons/remote_management.svg"
import manage_multiple from "../assets/images/icons/manage_multiple.svg"
import built from "../assets/images/icons/built.svg"
import delightful from "../assets/images/solutions/commercial/delightful.svg"
import heroBG from "../assets/images/commercial/heroBG.png"
import HelmetScript from "../common/helmetScripts"
import "aos/dist/aos.css"
import "./index.scss"
import "../assets/styles/gallery-grid.scss"
import "../assets/styles/gallery-line.scss"
class SolutionsEnterprise extends React.Component {
  componentDidMount() {
    const AOS = require("aos")
    this.aos = AOS
    this.aos.init()
  }

  componentDidUpdate() {
    this.aos.refresh()
  }
  render() {
    return (
      <Layout location={this.props.location}>
        <Navigation />
        <HelmetScript />
        <Helmet title="Swiftlane: Commercial real estate and office key card, badge, access control system.">
          <html lang="en" />
          <meta
            name="description"
            content="Install Swiftlane cloud access control for Commercial Buildings, Businesses, property managers, Landlords and Property Managers. Tenant door access and security. Face and Mobile badge access. Replace key cards and badges."
          ></meta>
          <meta
            name="keywords"
            content="Swiftlane, commercial buildings, multi tenant commercial, turnstile access, cloud access control, badges"
          />
        </Helmet>
        <Hero
          info="SWIFTLANE FOR COMMERCIAL REAL ESTATE"
          bg={heroBG}
          title="Built to meet the needs of commercial buildings"
          subTitle="Improve security and reduce operational costs & overhead, while delighting your tenants."
          getAQuote="Get a Quote"
        />
        <div className="wrapper products-page">
          <div className="home-content container homePage-design">
            <div className="box">
              <Row>
                <Col md={12} className="text-left">
                  <div className="icon-set">
                    <img src={current_access_icon} alt="Door Icon" />
                  </div>
                  <h2>Create a modern workplace experience</h2>
                  <h3>
                    Provide the most modern access experience to your tenants
                    using Swiftlane access
                  </h3>
                  <ul>
                    <li>Mobile phone based access</li>
                    <li>Face Recognition access</li>
                    <li>Secure and convenient</li>
                  </ul>
                </Col>
                <Col md={12} className="text-right">
                  <img src={swiftlane_face} alt="mobile" />
                </Col>
              </Row>
            </div>
            {/* end of box */}

            <section className="gallery-section oldDesign">
              <div className="container">
                <h2>High security for a fraction of the cost</h2>
                <p>
                  Manage high traffic across all your tenants securely, with the
                  Swiftlane unique multi factor access combined with operational
                  intelligence
                </p>
                <Row gutter={24}>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={fast_entollment} alt="Icon" />
                    <h4>Easy enrollment</h4>
                    <p>
                      Enroll your users from your desk, no need to make a trip
                      to the server room
                    </p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={real_time_activity_feed} alt="Icon" />
                    <h4>Real time activity feed</h4>
                    <p>
                      Watch realtime access activity and visually verify every
                      person’s face
                    </p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={visual_verification} alt="Icon" />
                    <h4>Visual Verification</h4>
                    <p>
                      Visual verification at the door prevents unauthorized
                      access
                    </p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={auditing} alt="Icon" />
                    <h4>Auditing and Analytics</h4>
                    <p>
                      Identify anomalies and respond to events faster than ever
                    </p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={remote_management} alt="Icon" />
                    <h4>Remote Management</h4>
                    <p>Manage your sites live from anywhere</p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={auditing} alt="Icon" />
                    <h4>Detailed roles and permissions</h4>
                    <p>
                      Easily manage multiple tenants from a single dashboard
                    </p>
                  </Col>
                </Row>
              </div>
            </section>

            <div className="box">
              <Row>
                <Col md={12} className="text-left">
                  <div className="icon-set">
                    <img src={manage_multiple} alt="Door Icon" />
                  </div>
                  <h2>Manage multiple sites</h2>
                  <h3>
                    Swiftlane’s cloud based system provides management from
                    anywhere in the world, and deployed over a fleet of scalable
                    and distributed servers
                  </h3>
                </Col>
                <Col md={12} className="text-right">
                  <img src={manage_multiple_sites} alt="mobile" />
                </Col>
              </Row>
            </div>
            {/* end of box */}

            <section className="gallery-section oldDesign">
              <div className="container">
                <div className="top-icon">
                  <img src={delightful} alt="Icon" />
                </div>
                <h2>Delightful Access Experience</h2>
                <p>
                  Swiftlane’s access solution provides a convenient and
                  delightful access experience to your users
                </p>
              </div>
            </section>

            <div className="box">
              <Row>
                <Col md={12} className="text-left">
                  <div className="icon-set">
                    <img src={swiftlane_system_icon} alt="Door Icon" />
                  </div>
                  <h2>Swiftlane system is designed with end to end security</h2>
                  <h3>
                    All swiftlane communication happens over secure channels.
                    All our wireless communication uses encrypted messages, TLS
                    security and HTTPS for web traffic. All biometric data is
                    encrypted before storing
                  </h3>
                </Col>
                <Col md={12} className="text-right">
                  <img src={swiftlane_system} alt="mobile" />
                </Col>
              </Row>
            </div>
            {/* end of box */}
          </div>

          <section className="gallery-section oldDesign">
            <div className="container">
              <div className="top-icon">
                <img src={built} alt="Icon" />
              </div>
              <h2>Privacy first design</h2>
              <p>
                At Swiftlane, we care deeply about our customer’s privacy. We do
                not sell customer data, and take care in protecting the
                integrity, safety and handling of customer data. Read our
                complete privacy policy{" "}
                <a href="/privacy" hrefLang="en-us" rel="alternate">
                  here
                </a>
                .
              </p>
            </div>
          </section>
        </div>
        <Subscribe location={this.props.location} />
        <Footer />
      </Layout>
    )
  }
}

export default SolutionsEnterprise
